// import React from "react";

// interface INewsImage {
//   newsImage: string;
//   isDark: boolean;
//   date: string;
//   details: string;
//   category: string;
//   title: string;
// }

// const NewsLatest: React.FC<INewsImage> = ({
//   newsImage,
//   isDark,
//   title,
//   date,
//   details,
//   category,
// }) => {
//   return (
//     <div
//       className={`flex flex-col items-center justify-start gap-2 p-[4px] cursor-pointer mb-2 ${
//         isDark ? "hover:bg-darkBg" : "hover:bg-lightBg"
//       }`}
//     >
//       <img className="w-full" src={newsImage} alt="sampleNews" />
//       <div className="w-full p-[4px]">
//         <h2 className="text-xs">
//           {category} / {date}
//         </h2>
//         <h1 className="sm:text-lg text-sm font-semibold">{title}</h1>
//         <p className="sm:text-sm text-xs">{details}</p>
//       </div>
//     </div>
//   );
// };

// export default NewsLatest;

// ------ version 2 ---------
import React from "react";
import { handleTitleClick } from "../../../pages/news/data";

interface INewsImage {
  newsImage: string;
  isDark: boolean;
  date: string;
  details: string;
  category: string;
  title: string;
  slug: string;
}

const NewsLatest: React.FC<INewsImage> = ({
  newsImage,
  isDark,
  title,
  date,
  details,
  category,
  slug,
}) => {
  return (
    <div
      className={`flex flex-col rounded-lg shadow-sm overflow-hidden transition-shadow duration-200 ${
        isDark
          ? "bg-darkBg text-white hover:shadow-md"
          : "bg-white text-gray-900 hover:shadow-md"
      }`}
    >
      <img
        className="w-full h-48 object-cover"
        src={newsImage}
        alt="Latest news"
      />
      <div className="p-4">
        <p
          className={`text-xs ${
            isDark ? "text-white" : "text-gray-500"
          } dark:text-gray-400`}
        >
          {category} • {date}
        </p>
        <h1
          onClick={() => {
            handleTitleClick(slug);
          }}
          className={`mt-2 ${
            isDark ? "text-white" : "text-gray-400"
          } cursor-pointer text-base sm:text-lg font-medium line-clamp-2`}
        >
          {title}
        </h1>
        <p
          className={`mt-1 ${
            isDark ? "text-white" : "text-gray-700"
          } text-sm dark:text-gray-300 line-clamp-3`}
        >
          {details}
        </p>
      </div>
    </div>
  );
};

export default NewsLatest;
